import React from "react"
import { contrast } from "helpers/contrast"

import DefaultAvatar from "assets/images/default-user.png"

import "styles/components/common/avatar.scss"

function addPx(num) {
  if (!isNaN(num)) {
    return num.toString(10) + "px"
  }
  return num
}

function getInitials(name, delimeter) {
  if (name) {
    var array = name.split(delimeter)
    switch (array.length) {
      case 1:
        return array[0].charAt(0).toUpperCase()
      default:
        return (
          array[0].charAt(0).toUpperCase() +
          array[array.length - 1].charAt(0).toUpperCase()
        )
    }
  }
  return false
}

class Avatar extends React.Component {
  render() {
    let {
      borderRadius = "100%",
      src,
      srcset,
      name,
      color,
      size,
      style,
      className,
    } = this.props

    // if (!name) throw new Error("Avatar requires a name");

    size = addPx(size)

    const imageStyle = {
      display: "block",
      borderRadius,
    }

    const innerStyle = {
      lineHeight: size,
      textAlign: "center",
      borderRadius,
    }

    if (size) {
      imageStyle.width = innerStyle.width = innerStyle.maxWidth = size
      imageStyle.height = innerStyle.height = innerStyle.maxHeight = size
    }

    let inner,
      classes = [className, "Avatar"]
    if (src || srcset) {
      inner = (
        <img
          className="Avatar--img"
          style={imageStyle}
          src={src}
          srcSet={srcset}
          alt={name}
          onError={(e) => (e.target.src = { DefaultAvatar })}
        />
      )
    } else {
      let background
      if (color) {
        background = color
      } else {
        background = localStorage.getItem("app-theme")
      }

      innerStyle.backgroundColor = background

      inner = getInitials(name, " ")
    }

    if (innerStyle.backgroundColor) {
      classes.push(`Avatar--${contrast(innerStyle.backgroundColor)}`)
    }

    return (
      <div aria-label={name} className={classes.join(" ")} style={style}>
        <div className="Avatar--inner" style={innerStyle}>
          {inner}
        </div>
      </div>
    )
  }
}

export default Avatar
